<app-page-header title="Mi perfil" subtitle="Gestiona tu cuenta" [accent]="true"></app-page-header>

<div class="profile-layout">
    <div class="container profile-layout-inner">

        <div *ngIf="loadingProfile" class="container no-text-select pre-loading">
            <p>Cargando<span>.</span><span>.</span><span>.</span></p>
        </div>

        <ng-container *ngIf="!loadingProfile">
            <app-profile-sidebar
                [userFullName]="userFullName"
                [userEmail]="userEmail"
                [active]="activeOption"
                [hasLegalAssistanceProduct]="hasLegalAssistanceProduct"
                [isTaker]="isTaker"
                (optionChange)="onOptionChange($event)">
            </app-profile-sidebar>

            <app-profile-content
                [active]="activeOption"
                [profileData]="profileResponse"
                [paymentData]="paymentResponse">
            </app-profile-content>
        </ng-container>

    </div>
</div>

<app-footer></app-footer>
